import React from 'react';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';
import size from 'lodash/size';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import SurveyListItem from '../SurveyListItem';
import EmptyContent from '../../common/EmptyState/Content';
import {
  SURVEY_RESULTS,
  SURVEYS_ANSWERED_EMPTY,
} from '../../../constants/strings';
import WithLazyLoad from '../../../hocs/withLazyLoad';
import styles from './index.styl';

const SurveyResultList = ({
  surveyId,
  answeredList,
  onClickItem,
  intl: { formatMessage },
  sending,
  loadMore,
}) => (
  <div styleName="wrapper">
    <span styleName="title">{formatMessage(SURVEY_RESULTS)}</span>
    <div styleName="list">
      <WithLazyLoad loadMore={loadMore}>
        {answeredList.map(answeredSurvey => {
          return (
            <SurveyListItem
              key={`answered-${get(answeredSurvey, 'id')}`}
              title={get(answeredSurvey, 'name')}
              heading={get(answeredSurvey, 'frequency')}
              subtitle={get(answeredSurvey, 'assignments[0].program.name')}
              icon="up-surveys"
              active={surveyId === get(answeredSurvey, 'id')}
              onClick={() => {
                onClickItem(get(answeredSurvey, 'id'));
              }}
            />
          );
        })}
      </WithLazyLoad>
      <If condition={!size(answeredList) && !sending}>
        <div className="mt4">
          <EmptyContent
            icon="no-surveys"
            text={formatMessage(SURVEYS_ANSWERED_EMPTY)}
          />
        </div>
      </If>
    </div>
  </div>
);

SurveyResultList.propTypes = {
  surveyId: PropTypes.number,
  loadMore: PropTypes.func,
  answeredList: PropTypes.array,
  onClickItem: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  sending: PropTypes.bool,
};

SurveyResultList.defaultProps = {
  answeredList: [],
};

export default injectIntl(
  CSSModules(SurveyResultList, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveyResultList/index.jsx